import React, { FC } from 'react';
import { FaHome } from 'react-icons/fa';
import { IconProps } from './common/iconProps';

export const HomeIcon: FC<IconProps> = ({ className }) => <FaHome className={className} />;
